/**
 * Canonical id of a data or endpoint policy (BIGINT): no leading zeros, since
 * ids are compared as text, and at most 18 digits, so it always fits the column.
 */
export const POLICY_ID_PATTERN = /^[1-9]\d{0,17}$/;
